import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Pro from "./pages/Pro";
import Profile from "./components/Profile";
import Homepage from "./pages/Homepage";

function App() {
  return (
    <BrowserRouter>
      <div>
        <Switch>
          <Route path="/profile">
            <Profile />
          </Route>
          <Route path="/projects">
            <Pro />
          </Route>
          <Route path="/">
            <Homepage />
          </Route>
        </Switch>
      </div>
    </BrowserRouter>
  );
}

export default App;
